// extracted by mini-css-extract-plugin
module.exports = {"customdropdown":"dropdown-module--customdropdown--3Dfyi","dropdownIcon":"dropdown-module--dropdownIcon--3F6Tg"};